/* MSM content pages tools (DRAFT 2026-10-08). One file, initialised by data-cp="...". No libraries.
   Add-to-basket uses forms marked data-hp26-ajax, so the theme's existing quick-add handler (hp26-side-menu.js)
   adds the item and opens the cart drawer; without it the form simply posts to /cart/add. */
(function () {
  'use strict';
  var d = document;
  var U = { kg: 1, g: 0.001, oz: 0.0283495, lb: 0.453592, lbs: 0.453592 };
  /* Weight in kg from a product or variant title. Ranges use the midpoint (e.g. 4-5kg = 4.5kg). Null if none. */
  function weight(t) {
    if (!t) return null;
    t = String(t).toLowerCase().replace(/[\u2013\u2014]/g, '-').replace(/,/g, '');
    var m = t.match(/(\d+)\s*x\s*(\d+(?:\.\d+)?)\s*(kg|g|oz|lbs?)?\s*(?:-\s*(\d+(?:\.\d+)?)\s*)?(kg|g|oz|lbs?)\b/);
    if (m) { var u1 = U[m[3] || m[5]], u2 = U[m[5]]; var a = +m[2] * u1, b = m[4] ? +m[4] * u2 : a; return +m[1] * (a + b) / 2; }
    m = t.match(/(\d+(?:\.\d+)?)\s*(kg|g|oz|lbs?)?\s*-\s*(\d+(?:\.\d+)?)\s*(kg|g|oz|lbs?)\b/);
    if (m) { var ua = U[m[2] || m[4]], ub = U[m[4]]; return (+m[1] * ua + +m[3] * ub) / 2; }
    m = t.match(/(\d+(?:\.\d+)?)\s*(kg|g|oz|lbs?)\b/);
    if (m) return +m[1] * U[m[2]];
    return null;
  }
  /* Strict version for the price-per-kg table: skips multi-buy offers ("Buy 2kg ..., Get 2kg FREE", "6 Sirloins + 1.6kg Mince")
     and any title that still has a second weight after the first one is read, because the pack weight would be ambiguous. */
  function weightStrict(t) {
    if (!t || /\b(get|free|buy|plus)\b|\+/i.test(t)) return null;
    var w = weight(t); if (!w) return null;
    var s = String(t).toLowerCase().replace(/[\u2013\u2014]/g, '-').replace(/,/g, '')
      .replace(/(\d+)\s*x\s*(\d+(?:\.\d+)?)\s*(kg|g|oz|lbs?)?\s*(?:-\s*(\d+(?:\.\d+)?)\s*)?(kg|g|oz|lbs?)\b/, '')
      .replace(/(\d+(?:\.\d+)?)\s*(kg|g|oz|lbs?)?\s*-\s*(\d+(?:\.\d+)?)\s*(kg|g|oz|lbs?)\b/, '')
      .replace(/(\d+(?:\.\d+)?)\s*(kg|g|oz|lbs?)\b/, '');
    return /\d\s*(kg|g|oz|lbs?)\b/.test(s) ? null : w;
  }
  function money(p) { return '\u00a3' + (p / 100).toFixed(2); }
  function kg(x) { return x >= 1 ? (Math.round(x * 10) / 10).toString().replace(/\.0$/, '') + 'kg' : Math.round(x * 1000) + 'g'; }
  function hm(min) { min = Math.round(min); var h = Math.floor(min / 60), m = min % 60; return (h ? h + ' hr ' : '') + (m || !h ? m + ' min' : '').trim(); }
  function q(el, s) { return el.querySelector(s); }
  function qa(el, s) { return [].slice.call(el.querySelectorAll(s)); }
  function stepper(root) {
    qa(root, '[data-cp-step]').forEach(function (w) {
      var i = q(w, 'input');
      qa(w, 'button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = (+i.value || 0) + (+b.dataset.d), mn = +i.min || 0, mx = +i.max || 999;
          i.value = Math.max(mn, Math.min(mx, v)); i.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });
    });
  }
  function chips(group, cb) {
    qa(group, '.cp-chip').forEach(function (c) {
      c.addEventListener('click', function () {
        qa(group, '.cp-chip').forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        cb(c);
      });
    });
  }
  /* buy box: product data from <script type=application/json> */
  function buyBox(p, qty, label) {
    if (!p || !p.available) return '';
    return '<div class="cp-buy">' + (p.img ? '<img src="' + p.img + '" alt="' + p.alt.replace(/"/g, '&quot;') + '" width="72" height="72" loading="lazy">' : '') +
      '<div class="cp-buy__t"><a href="' + p.url + '">' + (qty > 1 ? qty + ' \u00d7 ' : '') + p.title + '</a><span class="cp-buy__p">' + money(p.price * qty) + (qty > 1 ? ' (' + money(p.price) + ' each)' : '') + '</span></div>' +
      '<form method="post" action="/cart/add" data-hp26-ajax><input type="hidden" name="id" value="' + p.variant + '"><input type="hidden" name="quantity" value="' + qty + '">' +
      '<button type="submit" class="msm26-btn msm26-btn--red">' + (label || 'Add to basket') + '</button></form></div>';
  }
  function data(el) { try { return JSON.parse(q(el, 'script[type="application/json"]').textContent); } catch (e) { return null; } }

  /* ---------- How much meat planner ---------- */
  function planner(root) {
    var D = data(root); if (!D) return;
    var g = q(root, '[name=guests]'), lo = q(root, '[name=leftovers]'), two = q(root, '[name=two]'), out = q(root, '[data-cp-out]'), cur = D.meats[0];
    stepper(root);
    chips(q(root, '[data-cp-meats]'), function (c) { cur = D.meats[+c.dataset.i]; run(); });
    function run() {
      var n = Math.max(1, +g.value || 1), f = two.checked ? 2 / 3 : 1;
      var a = (lo.checked ? cur.left_min : cur.min) * n * f / 1000, b = (lo.checked ? cur.left_max : cur.max) * n * f / 1000;
      var h = '<h3>' + cur.label + ' for ' + n + (n === 1 ? ' person' : ' people') + '</h3><p class="cp-big">' + kg(a) + (b > a ? '\u2013' + kg(b) : '') + '</p><p>raw weight' + (lo.checked ? ', with leftovers' : '') + (two.checked ? ', serving two meats' : '') + '</p>';
      var p = cur.product, w = p && weight(p.wtitle);
      if (p && p.available && w) { var qty = Math.max(1, Math.ceil(((a + b) / 2) / w - 0.15)); h += '<p>That is about <strong>' + qty + ' \u00d7 ' + p.title + '</strong> (' + kg(qty * w) + ').</p>' + buyBox(p, qty); }
      else if (cur.link) h += '<p><a class="msm26-btn msm26-btn--white" href="' + cur.link + '">Shop ' + cur.label.toLowerCase() + '</a></p>';
      out.innerHTML = h;
    }
    [g, lo, two].forEach(function (i) { i.addEventListener('input', run); i.addEventListener('change', run); });
    run();
  }

  /* ---------- Roast cooking time calculator ---------- */
  function roast(root) {
    var D = data(root); if (!D) return;
    var sel = q(root, '[name=joint]'), wt = q(root, '[name=weight]'), lv = q(root, '[data-cp-levels]'), ready = q(root, '[name=ready]'), out = q(root, '[data-cp-out]');
    var j, level = 0;
    function setJoint() {
      j = D.joints[+sel.value]; level = Math.min(level, j.levels.length - 1);
      var w = j.product && weight(j.product.wtitle); if (w) wt.value = (Math.round(w * 10) / 10);
      lv.innerHTML = j.levels.map(function (l, i) { return '<button type="button" class="cp-chip" aria-pressed="' + (i === level) + '" data-i="' + i + '">' + l.name + '</button>'; }).join('');
      qa(lv, '.cp-chip').forEach(function (c) { c.addEventListener('click', function () { level = +c.dataset.i; qa(lv, '.cp-chip').forEach(function (x) { x.setAttribute('aria-pressed', x === c); }); run(); }); });
      run();
    }
    function run() {
      var k = parseFloat(String(wt.value).replace(',', '.'));
      if (!(k > 0.2 && k < 15)) { out.innerHTML = '<h3>Enter a weight</h3><p>Type the joint weight in kg, between 0.3 and 15.</p>'; return; }
      var l = j.levels[level], cook = Math.round((l.per * k * 1000 / 450 + l.extra) / 5) * 5;
      var h = '<h3>' + j.label + ', ' + k + 'kg, ' + l.name.toLowerCase() + '</h3><p class="cp-big">' + hm(cook) + '</p><p>cooking time' + (j.method ? ' (total)' : ' in the oven') + ', plus resting</p>';
      h += '<div class="cp-kv"><div><b>Oven</b><span>' + j.oven + '</span></div><div><b>Rest</b><span>' + j.rest + '</span></div>' + (l.temp ? '<div><b>Centre temperature</b><span>' + l.temp + '</span></div>' : '') + '<div><b>Rule</b><span>' + l.per + ' min per 450g + ' + l.extra + '</span></div></div>';
      if (j.method) h += '<p>' + j.method + '</p>';
      if (ready.value) {
        var p = ready.value.split(':'), t = (+p[0]) * 60 + (+p[1]), rest = j.rest_min || 0, inn = t - rest - cook;
        var f = function (x) { x = ((x % 1440) + 1440) % 1440; return ('0' + Math.floor(x / 60)).slice(-2) + ':' + ('0' + (x % 60)).slice(-2); };
        h += '<p><strong>Oven in at ' + f(inn) + '</strong>, out at ' + f(t - rest) + ', rest, then carve at ' + f(t) + '. Add time to preheat the oven.</p>';
      }
      if (j.product && j.product.available) h += buyBox(j.product, 1);
      out.innerHTML = h;
    }
    sel.addEventListener('change', setJoint); wt.addEventListener('input', run); ready.addEventListener('input', run);
    setJoint();
  }

  /* ---------- Christmas countdown (only when an ISO date is set in the section) ---------- */
  function dates(root) {
    var iso = root.dataset.iso, box = q(root, '[data-cp-count]'); if (!iso || !box) return;
    var end = new Date(iso + 'T23:59:59'); if (isNaN(end)) return;
    function tick() {
      var s = Math.max(0, (end - new Date()) / 1000), dd = Math.floor(s / 86400), hh = Math.floor(s % 86400 / 3600), mm = Math.floor(s % 3600 / 60);
      box.innerHTML = '<div><b>' + dd + '</b>days</div><div><b>' + hh + '</b>hours</div><div><b>' + mm + '</b>mins</div>'; box.hidden = false;
    }
    tick(); setInterval(tick, 30000);
  }

  /* ---------- Cuts chart ---------- */
  function chart(root) {
    var tabs = qa(root, '[data-cp-animal]'), svgs = qa(root, '[data-cp-svg]'), panel = q(root, '[data-cp-panel]');
    function show(a, region) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.cpAnimal === a); });
      svgs.forEach(function (s) { s.classList.toggle('cp-hidden', s.dataset.cpSvg !== a); });
      var cards = qa(root, '[data-cp-cut][data-a="' + a + '"]');
      var c = region ? cards.filter(function (x) { return x.dataset.r === region; })[0] : cards[0];
      if (!c) return;
      qa(root, '.cp-reg').forEach(function (r) { r.classList.toggle('is-on', r.closest('[data-cp-svg]').dataset.cpSvg === a && r.dataset.r === c.dataset.r); });
      panel.innerHTML = c.innerHTML.replace(/<h3/, '<h3 tabindex="-1"');
      return c;
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.cpAnimal); }); });
    qa(root, '.cp-reg').forEach(function (r) {
      var go = function () { show(r.closest('[data-cp-svg]').dataset.cpSvg, r.dataset.r); if (window.innerWidth < 900) panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); };
      r.addEventListener('click', go);
      r.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
    });
    show(tabs[0] ? tabs[0].dataset.cpAnimal : 'beef');
  }

  /* ---------- Gift finder (filter by live price) ---------- */
  function gifts(root) {
    var cards = qa(root, '[data-min]'), cnt = q(root, '[data-cp-n]');
    chips(q(root, '[data-cp-budget]'), function (c) {
      var lo = +c.dataset.lo, hi = +c.dataset.hi, n = 0;
      cards.forEach(function (x) { var ok = +x.dataset.max >= lo && +x.dataset.min <= hi; x.classList.toggle('cp-hidden', !ok); if (ok) n++; });
      if (cnt) cnt.textContent = n + (n === 1 ? ' gift' : ' gifts');
    });
  }

  /* ---------- Price per kg table (weights parsed from live titles at render time) ---------- */
  function ppk(root) {
    var D = data(root); if (!D) return;
    var tb = q(root, 'tbody'), cnt = q(root, '[data-cp-n]'), srch = q(root, '[name=search]'), type = 'all', sort = 'ppk';
    var rows = [], seen = {};
    D.items.forEach(function (p) {
      var w = weightStrict(p.vtitle) || weightStrict(p.title); if (!w) return;
      var key = p.title + '|' + (weightStrict(p.vtitle) ? p.vtitle : '') + '|' + p.price; if (seen[key]) return; seen[key] = 1;
      rows.push({ t: p.title + (p.vtitle && weightStrict(p.vtitle) ? ' \u2013 ' + p.vtitle : ''), url: p.url, type: p.type, price: p.price, cmp: p.compare, w: w, ppk: p.price / w });
    });
    function draw() {
      var s = (srch.value || '').toLowerCase().trim();
      var list = rows.filter(function (r) { return (type === 'all' || r.type === type) && (!s || r.t.toLowerCase().indexOf(s) > -1); });
      list.sort(function (a, b) { return sort === 'ppk' ? a.ppk - b.ppk : sort === 'ppk-d' ? b.ppk - a.ppk : a.price - b.price; });
      tb.innerHTML = list.map(function (r) {
        return '<tr><td data-th="Product"><a href="' + r.url + '">' + r.t + '</a></td><td data-th="Type">' + r.type + '</td><td data-th="Pack weight" class="num">' + kg(r.w) + '</td><td data-th="Price" class="num"><span>' + money(r.price) + (r.cmp > r.price ? ' <s>' + money(r.cmp) + '</s>' : '') + '</span></td><td data-th="Price per kg" class="num"><strong>' + money(r.ppk) + '/kg</strong></td></tr>';
      }).join('') || '<tr><td colspan="5">No matching products.</td></tr>';
      cnt.textContent = list.length + ' of ' + rows.length + ' products shown';
    }
    chips(q(root, '[data-cp-types]'), function (c) { type = c.dataset.t; draw(); });
    q(root, '[name=sort]').addEventListener('change', function (e) { sort = e.target.value; draw(); });
    srch.addEventListener('input', draw);
    draw();
  }

  /* ---------- Meal prep planner ---------- */
  function prep(root) {
    var D = data(root); if (!D) return;
    var meals = q(root, '[name=meals]'), weeks = q(root, '[name=weeks]'), out = q(root, '[data-cp-out]'), portion = D.portions[1] || D.portions[0], cur = D.meats[0];
    stepper(root);
    chips(q(root, '[data-cp-portion]'), function (c) { portion = +c.dataset.g; run(); });
    chips(q(root, '[data-cp-meats]'), function (c) { cur = D.meats[+c.dataset.i]; run(); });
    function run() {
      var n = Math.max(1, +meals.value || 1) * (+weeks.value || 1), need = n * portion / 1000;
      var h = '<h3>' + n + ' portions of ' + portion + 'g</h3><p class="cp-big">' + kg(need) + '</p><p>raw ' + cur.label.toLowerCase() + ' needed</p>';
      var p = cur.product, w = p && weight(p.wtitle);
      if (p && p.available && w) {
        var qty = Math.max(1, Math.ceil(need / w - 0.05)), per = p.price / (w * 1000 / portion);
        h += '<div class="cp-kv"><div><b>Pack</b><span>' + kg(w) + '</span></div><div><b>Price per kg</b><span>' + money(p.price / w) + '</span></div><div><b>Per ' + portion + 'g portion</b><span>' + money(per) + '</span></div><div><b>Packs needed</b><span>' + qty + '</span></div></div>' + buyBox(p, qty);
      }
      out.innerHTML = h;
    }
    [meals, weeks].forEach(function (i) { i.addEventListener('input', run); i.addEventListener('change', run); });
    run();
  }

  var init = { planner: planner, roast: roast, dates: dates, chart: chart, gifts: gifts, ppk: ppk, prep: prep };
  function boot() { qa(d, '[data-cp]').forEach(function (el) { if (el.dataset.cpOn) return; el.dataset.cpOn = 1; try { init[el.dataset.cp](el); } catch (e) { if (window.console) console.warn('msm-cp', el.dataset.cp, e); } }); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', boot);
  window.msmCpWeight = weight; window.msmCpWeightStrict = weightStrict;
})();
